import { render, staticRenderFns } from "./HomeClinic.vue?vue&type=template&id=17788c5f&"
import script from "./HomeClinic.vue?vue&type=script&lang=js&"
export * from "./HomeClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports